import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_edi_sftp_pushService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { integration_id: string, file_content: string, transaction_type?: string }): Promise<void> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.integration_id)) {
      $missingRequiredInParams.push('\'integration_id\'');
    }
    if (isNil($inParams.file_content)) {
      $missingRequiredInParams.push('\'file_content\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/app/functions/edi_sftp_push`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

